/** 案件で求めるサブ条件：サブ種別 日本語 */
export const RFP_REQUIRED_SUB_CONDITION_SUB_TYPE_JAPANESE = {
    label: '日本語',
    value: 1,
};
/** 案件で求めるサブ条件：サブ種別 英語 */
export const RFP_REQUIRED_SUB_CONDITION_SUB_TYPE_ENGLISH = {
    label: '英語',
    value: 2,
};
/** 案件で求めるサブ条件：サブ種別 どちらでも可 */
export const RFP_REQUIRED_SUB_CONDITION_SUB_TYPE_EITHER = {
    label: 'どちらでも可',
    value: 9,
};
/** 案件で求めるサブ条件：サブ種別の一覧 */
export const RFP_REQUIRED_SUB_CONDITION_SUB_TYPES = [
    RFP_REQUIRED_SUB_CONDITION_SUB_TYPE_JAPANESE,
    RFP_REQUIRED_SUB_CONDITION_SUB_TYPE_ENGLISH,
    RFP_REQUIRED_SUB_CONDITION_SUB_TYPE_EITHER,
];
